@import '../../../globals/main.scss';
@import './pn-language-common.scss';

pn-language-selector-option {
  margin: 0;
  padding: 0;
  list-style: none;
}

.languageselector-button,
.languageselector-link {
  width: 100%;
  padding: 1.1rem 1.6rem 1.1rem 1.4rem;
  display: flex;
  align-items: center;
  position: relative;
  text-decoration: none;
  border: 0;
  cursor: pointer;
  background-color: $white;
  color: $blue700;
  font-size: 1.6rem;
  font-weight: bold;
  border-radius: 0;
  &:hover,
  &:focus,
  &:active {
    color: $blue900;
    text-decoration: underline;
    box-shadow: none;
    background-color: $gray50;
    color: $blue700;
    outline: none;
  }
}

.languageselector-itemtext {
  display: inline-block;
  margin-left: 1rem;
}

.languageselector-radio-outer {
  background: #fff;
  border: 0.1em solid $gray200;
  border-radius: 50%;
  height: 1.5em;
  width: 1.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    border 0.2s ease-in-out,
    background-color 0.2s ease-in-out,
    box-shadow 0.1s;
  cursor: pointer;

  &:focus > &,
  &:active > & {
    box-shadow:
      0 0 0 0.1rem white,
      0 0 0 0.3rem $blue700;
  }
  &:hover > & {
    border: 0.1rem solid $blue700;
    background: $blue50;
  }
  [selected='true'] & {
    border: 0.1rem solid $blue700;
  }
}

.languageselector-radio-inner {
  transform: scale(0);
  height: 1em;
  width: 1em;
  background-color: $blue700;
  border-radius: 50%;
  transform-origin: center center;
  transition: transform 0.1s cubic-bezier(0.64, 0.01, 0.67, 0.92);

  [selected='true'] & {
    transform: scale(1);
  }
}
